import * as types from './types';

export const addAndRule = () => ({
  type: types.ADD_AND_RULE,
});

export const getFilters = () => ({
  type: types.GET_FILTERS,
});

export const addOrRule = index => ({
  type: types.ADD_OR_RULE,
  index,
});

export const updateOrRule = (index, payload) => ({
  type: types.UPDATE_OR_RULE,
  index,
  payload,
});

export const deleteOrRule = index => ({
  type: types.DELETE_OR_RULE,
  index,
});

export const applyFilter = payload => ({
  type: types.APPLY_FILTER,
  payload,
});

export const createFilter = payload => ({
  type: types.CREATE_FILTER,
  payload,
});

export const deleteFilter = id => ({
  type: types.DELETE_FILTER,
  id,
});

export const startEditFilter = (payload) => ({
  type: types.START_EDIT_FILTER,
  payload,
});

export const createAndApplyFilter = payload => ({
  type: types.CREATE_AND_APPLY,
  payload,
});

export const updateFilter = (fid, payload) => ({
  type: types.UPDATE_FILTER,
  fid,
  payload,
});

export const updateAndApplyFilter = (fid, payload) => ({
  type: types.UPDATE_AND_APPLY,
  fid,
  payload,
});

export const updateActiveTab = key => ({
  type: types.UPDATE_ACTIVE_TAB,
  key,
});

export const updateMeta = (categories, dimensions) => ({
  type: types.UPDATE_META,
  categories,
  dimensions,
});

export const updateSelectedFilters = (filters, mode) => ({
  type: types.UPDATE_SELECTED_FILTERS,
  filters,
  mode,
});

export const updateFilterConditions = payload => ({
  type: types.UPDATE_FILTER_CONDITIONS,
  payload,
});

export const changeFilterContainerVisibility = visible => ({
  type: types.CHANGE_FILTER_CONTAINER_VISIBILITY,
  visible,
});

export const resetDrillDown = () => ({
  type: types.RESET_DRILL_DOWN,
});

export const setDefaultFilters = filters => ({
  type: types.SET_DEFAULT_FILTERS,
  filters,
});

export const clearFilterCache = () => ({
  type: types.CLEAR_FILTER_CACHE,
});

export const updateContentFilter = isContent => ({
  type: types.UPDATE_CONTENT_FILTER,
  isContent,
});

export const updateFilterHidden = hidden => ({
  type: types.UPDATE_FILTER_HIDDEN,
  hidden,
});